<template>
  <div class="mt-5 w-100">
    <div class="title mb-4">Conteúdos relacionados</div>

    <div v-if="loading" class="row">
      <div v-for="i in 2" :key="i" class="col-12 col-md-6 mb-2 p-2">
        <div class="card p-4 shadow-none border-light">
          <b-skeleton width="80%" height="24px" class="mb-2"></b-skeleton>
          <div class="mt-3">
            <b-skeleton width="100%" class="mb-1"></b-skeleton>
            <b-skeleton width="100%" class="mb-1"></b-skeleton>            
          </div>
        </div>
      </div>
    </div>

    <div v-else-if="items.length === 0" class="text-muted py-2">
      Nenhum conteúdo relacionado encontrado.
    </div>

    <div v-else class="row">
      <div class="col-12 col-md-6 mb-2 p-2" v-for="(obj, index) in items" :key="obj.id || index">
        <router-link :to="previewPath(obj.id)" class="text-decoration-none">
          <div class="card p-4 card-hover">
            <div class="title-card">
              {{ obj.title }}
            </div>
            <div class="text mt-2">
              {{ obj.coverCallout }}
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ConnectionService from "../../../services/connection/ConnectionService";
import RoutesPaths from "../../../router/router-structure/routes-paths";

export default {
  props: {
    contentId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      loading: true,
    };
  },
  watch: {
    contentId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.fetchRelated(id);
        } else {
          this.items = [];
          this.loading = false;
        }
      },
    },
  },
  methods: {
    async fetchRelated(id) {
      this.loading = true;
      this.items = [];
      try {
        this.items = await ConnectionService.getRelated(id);
      } catch (error) {
        console.error("Erro ao buscar conteúdos relacionados", error);
      } finally {
        this.loading = false;
      }
    },
    previewPath(id) {
      return RoutesPaths.connection.preview(id);
    },
  },
};

</script>

<style scoped>
.title {
  color: #3D3F40;
    font-family: "Trebuchet MS";
    font-size: 24px;
}

.card {
    border-radius: 4px;
    border: 1px solid #DFDFDF;
    background: #FFF;
    height: 140px;
}

.card-hover:hover {
    border-color: #00524D;
    background: #F8FAFA;
}

/* ... suas outras regras ... */

.title-card {
    color: #212529;
    font-family: "Trebuchet MS";
    font-size: 20px;
    
    /* Quebra em 2 linhas */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    text-overflow: ellipsis;
}

.text {
    color: var(--text-01-body, #212529);
    font-family: "Trebuchet MS";
    font-size: 12px;

    /* Quebra em 3 linhas */
    display: -webkit-box;
    -webkit-line-clamp: 3;
    line-clamp: 3;
    -webkit-box-orient: vertical;  
    overflow: hidden;
    text-overflow: ellipsis;
}


</style>